export const BAIDU_TEXT_ICON_OVERLAY = "TEXTICONOVERLAY";
export const BAIDU_TEXT_ICON_OVERLAY_ASSETS_URL =
    "/assets/js/textIconOverlay.min.js";
export const BAIDU_MARKER_CLUSTERER = "MARKERCLUSTERER";
export const BAIDU_MARKER_CLUSTERER_ASSETS_URL =
    "/assets/js/markerClusterer.min.js";
export const BAIDU_MAP_WINDOW_ATTRIBUTE = "BMapLib";
